namespace GeniuzPOS.Purchase {
    export interface PoPurOrderRow {
        Id?: number;
        SysDocNo?: string;
        PurDocNo?: string;
        DocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        ConcatRefDocNo1?: string;
        RefDocNo2?: string;
        SupplierId?: string;
        SupplName?: string;
        ShipId?: string;
        ShipName?: string;
        ShipLineAddress1?: string;
        ShipLineAddress2?: string;
        ShipLineAddress3?: string;
        ShipDate?: string;
        PayTermCode?: string;
        WhsId?: string;
        VatFg?: VatFgstatus;
        TotalAmt?: number;
        DiscText?: string;
        DiscAmt?: number;
        SalesVatTypes?: string;
        VatCode?: string;
        VatRate?: number;
        VatAmt?: number;
        PurOrderAmt?: number;
        Remark?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        UseFg?: number;
        LastDateStatusChange?: string;
        Refuse?: string;
        SendForAppfg?: sendapp;
        CancelFg?: CancelFgstatus;
        RejectFg?: number;
        CheckQty?: number;
        ApproveFg?: ApproveFgonApptran;
        ApproveLv?: number;
        ApproveBy?: string;
        ApproveDate?: string;
        DtList?: PoPurOrderDtRow[];
        ShopId?: string;
        NetAmt?: number;
        NetExVat?: number;
        NetTotalInVat?: number;
        CashOrTermfg?: CashOrTermfg;
        DepositAmt?: number;
        POTypeFg?: POTypeFg;
        BranchCode?: string;
    }

    export namespace PoPurOrderRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.PoPurOrder';
        export const lookupKey = 'Purchase.PoPurOrder';

        export function getLookup(): Q.Lookup<PoPurOrderRow> {
            return Q.getLookup<PoPurOrderRow>('Purchase.PoPurOrder');
        }
        export const deletePermission = '5Purchase:ใบสั่งซื้อ(PO):สร้าง:Modify';
        export const insertPermission = '5Purchase:ใบสั่งซื้อ(PO):สร้าง:Modify';
        export const readPermission = '5Purchase:ใบสั่งซื้อ(PO):สร้าง:View';
        export const updatePermission = '5Purchase:ใบสั่งซื้อ(PO):สร้าง:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            PurDocNo = "PurDocNo",
            DocNo = "DocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            ConcatRefDocNo1 = "ConcatRefDocNo1",
            RefDocNo2 = "RefDocNo2",
            SupplierId = "SupplierId",
            SupplName = "SupplName",
            ShipId = "ShipId",
            ShipName = "ShipName",
            ShipLineAddress1 = "ShipLineAddress1",
            ShipLineAddress2 = "ShipLineAddress2",
            ShipLineAddress3 = "ShipLineAddress3",
            ShipDate = "ShipDate",
            PayTermCode = "PayTermCode",
            WhsId = "WhsId",
            VatFg = "VatFg",
            TotalAmt = "TotalAmt",
            DiscText = "DiscText",
            DiscAmt = "DiscAmt",
            SalesVatTypes = "SalesVatTypes",
            VatCode = "VatCode",
            VatRate = "VatRate",
            VatAmt = "VatAmt",
            PurOrderAmt = "PurOrderAmt",
            Remark = "Remark",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            UseFg = "UseFg",
            LastDateStatusChange = "LastDateStatusChange",
            Refuse = "Refuse",
            SendForAppfg = "SendForAppfg",
            CancelFg = "CancelFg",
            RejectFg = "RejectFg",
            CheckQty = "CheckQty",
            ApproveFg = "ApproveFg",
            ApproveLv = "ApproveLv",
            ApproveBy = "ApproveBy",
            ApproveDate = "ApproveDate",
            DtList = "DtList",
            ShopId = "ShopId",
            NetAmt = "NetAmt",
            NetExVat = "NetExVat",
            NetTotalInVat = "NetTotalInVat",
            CashOrTermfg = "CashOrTermfg",
            DepositAmt = "DepositAmt",
            POTypeFg = "POTypeFg",
            BranchCode = "BranchCode"
        }
    }
}
